import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    SECONDARY_LIST_START: 'SECONDARY_LIST_START',
    SECONDARY_LIST_SUCCESS: 'SECONDARY_LIST_SUCCESS',
    SECONDARY_LIST_FAILED: 'SECONDARY_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const secondaryListStart = (data) => ({
   type: actionType.SECONDARY_LIST_START,
   payload: data
})

export const secondaryListSuccess = (data) => ({
    type: actionType.SECONDARY_LIST_SUCCESS,
    payload: data
})

export const secondaryListFailed = (data) => ({
    type: actionType.SECONDARY_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function secondaryListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.SECONDARY_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.SECONDARY_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.SECONDARY_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* secondaryListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allSecondaryPosition = response.data.data.allSecondarypositions.Secondarypositions ? response.data.data.allSecondarypositions.Secondarypositions : null
       yield put(secondaryListSuccess(allSecondaryPosition));
    } else {
      messagePopup('','SECONDARY List failed','error')   
      yield put(secondaryListFailed('SECONDARY List failed')) 
    }
   } catch (error) {
     messagePopup('','SECONDARY List failed','error')   
     yield put(secondaryListFailed('SECONDARY List failed')) 
   }
}

export function* watchSecondaryListSaga(){
    yield takeEvery(actionType.SECONDARY_LIST_START, secondaryListSaga)
}